/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useState} from 'react';
import {ScrollView, Text, View} from 'react-native';
import {connect} from 'react-redux';
import {formatDateTo} from '../../../../common/utils/functions';
import {
  defaultDevisValues,
  defaultValuesCapital,
  defaultValuesPension,
} from '../../../../data/constants/Assurance/assuranceRetraite';
import {MotClef} from '../../../../data/constants/motClef';
import {
  ICapitalDTO,
  ICotisationDTO,
  IMotClef,
  IPensionDTO,
  IRequiredFields,
  IRequiredFieldsCapital,
  IRequiredFieldsPension,
} from '../../../../data/types/interface/Assurance/assuranceRetraite';
import {dataOption} from '../../../../data/types/interface/input';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import TypeVersementTab from '../../../components/Assurance/Retraite/TypeVersementTab';
import {Container} from '../../../components/Container';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {formsStyles} from '../../../components/Inputs/formStyles';
import Select from '../../../components/Inputs/Select';
import Label from '../../../components/Label';
import {Loader} from '../../../components/Loader';
import TooltipWeb from '../../../components/Tooltip/TooltipWeb';
import FormCapitalWeb from './Forms/Capital/FormCapitalWeb';
import FormCotisationWeb from './Forms/Cotisation/FormCotisationWeb';
import FormPensionWeb from './Forms/Pension/FormPensionWeb';
import styles from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'Cotisation'>;

const aList: dataOption[] = [
  {
    label: 'Assurance retraite',
    value: 'Assurance retraite',
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SimulationCotisationScreen = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {motCleUser, addSimulationTypeassurance, user, modeVersementUser} =
    props;
  let defaultMotClef = MotClef.Cotisation;
  const [motClef, setMotClef] = React.useState<IMotClef>();
  const [type, setType] = React.useState('Cotisation');
  const [IsLoading, setIsLoading] = React.useState(true);
  const [RequiredFieldsCotisation, setRequiredFieldsCotisation] =
    React.useState<IRequiredFields>({
      DateNaissance: false,
      Cotisation: false,
      ModeVersement: false,
    });
  const [RequiredFieldsCapital, setRequiredFieldsCapital] =
    React.useState<IRequiredFieldsCapital>({
      DateNaissance: false,
      Capital: false,
      ModeVersement: false,
    });
  const [RequiredFieldsPension, setRequiredFieldsPension] =
    React.useState<IRequiredFieldsPension>({
      DateNaissance: false,
      Pension: false,
      ModeVersement: false,
    });

  const [cotisationDTO, setCotisationDTO] =
    React.useState<ICotisationDTO>(defaultDevisValues);
  const [pensionDTO, setPensionDTO] =
    React.useState<IPensionDTO>(defaultValuesPension);
  const [capitalDTO, setCapitalDTO] =
    React.useState<ICapitalDTO>(defaultValuesCapital);

  useEffect(() => {
    modeVersementUser('Tous les jours', () => {});
    switch (type) {
      case 'Pension':
        defaultMotClef = MotClef.Pension;
        break;
      case 'Capital':
        defaultMotClef = MotClef.CapitalRetraite;
        break;
      case 'Cotisation':
        defaultMotClef = MotClef.Cotisation;
        break;
      default:
        break;
    }
    motCle(defaultMotClef);
    setIsLoading(false);
  }, []);
  const motCle = (mot: string) => {
    motCleUser(
      {},
      (res: any) => {
        res && setMotClef(res.motCle);
      },
      `?mot=${mot}`,
    );
  };

  const callBack = (name: string, value: any) => {
    modeVersementUser(value, () => {});

    switch (type) {
      case 'Cotisation':
        setCotisationDTO({...cotisationDTO, [name]: value});
        setRequiredFieldsCotisation({
          DateNaissance: cotisationDTO.DateNaissance === '',
          Cotisation: cotisationDTO.Cotisation === '',
          ModeVersement: cotisationDTO.ModeVersement === '',
        });
        break;
      case 'Pension':
        setPensionDTO({...pensionDTO, [name]: value});
        setRequiredFieldsPension({
          DateNaissance: pensionDTO.DateNaissance === '',
          Pension: pensionDTO.Pension === '',
          ModeVersement: pensionDTO.ModeVersement === '',
        });

        break;
      case 'Capital':
        setCapitalDTO({...capitalDTO, [name]: value});
        setRequiredFieldsCapital({
          DateNaissance: capitalDTO.DateNaissance === '',
          Capital: capitalDTO.Capital === '',
          ModeVersement: capitalDTO.ModeVersement === '',
        });

        break;
      default:
        break;
    }
  };

  const [isSubmited, setIsSubmited] = useState({
    cotisation: false,
    pension: false,
    capital: false,
  });
  const handleSubmit = (isSubmit: boolean) => {
    isSubmit && processSave();
    !isSubmit && goBack();
  };

  const getVersement = (typeVersement: string) => {
    let versement = 1;
    switch (typeVersement) {
      case 'Tous les ans':
        versement = 2;
        break;
      case 'Tous les mois':
        versement = 1;
        break;
      case 'Une seule fois':
        versement = 3;
        break;
      default:
        break;
    }

    return versement;
  };

  const getChoixRetraite = () => {
    let choixRetraite = 1;
    switch (type) {
      case 'Cotisation':
        choixRetraite = 1;
        break;
      case 'Pension':
        choixRetraite = 2;
        break;
      case 'Capital':
        choixRetraite = 3;
        break;
      default:
        break;
    }

    return choixRetraite;
  };
  const createDTO = () => {
    let data: any;

    switch (type) {
      case 'Cotisation':
        data = {
          dateNaissance: formatDateTo(
            cotisationDTO.DateNaissance,
            'DD/MM/YYYY',
          ),
          versement: getVersement(cotisationDTO.ModeVersement),
          choixRetraite: getChoixRetraite(),
          montantRetraiteCotisation: cotisationDTO.Cotisation,
        };
        break;
      case 'Pension':
        data = {
          dateNaissance: formatDateTo(pensionDTO.DateNaissance, 'DD/MM/YYYY'),
          versement: getVersement(pensionDTO.ModeVersement),
          choixRetraite: getChoixRetraite(),
          montantRetraiteCotisation: pensionDTO.Pension,
        };
        break;
      case 'Capital':
        data = {
          dateNaissance: formatDateTo(capitalDTO.DateNaissance, 'DD/MM/YYYY'),
          versement: getVersement(capitalDTO.ModeVersement),
          choixRetraite: getChoixRetraite(),
          montantRetraiteCotisation: capitalDTO.Capital,
        };
        break;
      default:
        break;
    }

    return data;
  };
  const processSave = () => {
    switch (type) {
      case 'Pension':
        setIsSubmited({
          cotisation: false,
          pension: true,
          capital: false,
        });
        setRequiredFieldsPension({
          DateNaissance: pensionDTO.DateNaissance === '',
          Pension: pensionDTO.Pension === '',
          ModeVersement: pensionDTO.ModeVersement === '',
        });

        pensionDTO.Pension !== '' &&
          pensionDTO.DateNaissance !== '' &&
          postData();
        break;

      case 'Capital':
        setIsSubmited({
          cotisation: false,
          pension: false,
          capital: true,
        });
        setRequiredFieldsCapital({
          DateNaissance: capitalDTO.DateNaissance === '',
          Capital: capitalDTO.Capital === '',
          ModeVersement: capitalDTO.ModeVersement === '',
        });

        capitalDTO.Capital !== '' &&
          capitalDTO.DateNaissance !== '' &&
          postData();

        break;
      case 'Cotisation':
        setIsSubmited({
          cotisation: true,
          pension: false,
          capital: false,
        });
        setRequiredFieldsCotisation({
          DateNaissance: cotisationDTO.DateNaissance === '',
          Cotisation: cotisationDTO.Cotisation === '',
          ModeVersement: cotisationDTO.ModeVersement === '',
        });
        cotisationDTO.Cotisation !== '' &&
          cotisationDTO.DateNaissance !== '' &&
          postData();
        break;
      default:
        break;
    }
  };
  const postData = () => {
    console.log(type);

    const DTO = createDTO();
    setIsLoading(true);
    addSimulationTypeassurance({...DTO}, () => {
      setIsLoading(false);
      switch (type) {
        case 'Pension':
          navigate('ResultatPension', {
            dateNaissance: pensionDTO.DateNaissance,
            premierVersement: pensionDTO.Pension,
          });
          break;
        case 'Capital':
          navigate('ResultatCapital', {
            dateNaissance: capitalDTO.DateNaissance,
            premierVersement: capitalDTO.Capital,
          });
          break;
        case 'Cotisation':
          navigate('ResultatCotisation', {
            dateNaissance: cotisationDTO.DateNaissance,
            premierVersement: cotisationDTO.Cotisation,
          });
          break;
        default:
          break;
      }
    });
  };

  const callBackTypeAssurance = (data: string) => {
    setType(data);
    switch (data) {
      case 'Pension':
        motCle(MotClef.Pension === 'PENSION' ? 'RENTE' : MotClef.Pension);
        break;
      case 'Capital':
        motCle(MotClef.CapitalRetraite);
        break;
      case 'Cotisation':
        motCle(MotClef.Cotisation);
        break;
      default:
        break;
    }
  };

  const handleSelect = useCallback(
    (name: string, data: string, fired: boolean) => {},
    [],
  );

  return (
    <Container>
      <View>
        <HeaderScreen
          type="retour"
          title="Demander simulation"
          noBreadcrumb={false}
        />
        <ScrollView>
          {IsLoading ? (
            <Loader />
          ) : (
            <View style={formsStyles.webformContain}>
              <View style={formsStyles.formContain}>
                <Label title="EPARGNE ET PREVOYANCE" type="mainTitle" />
                <Select
                  data={aList}
                  label="Mode de versement de la cotisation"
                  value={defaultDevisValues.ModeVersement}
                  onChange={handleSelect}
                  required={true}
                />
                <TypeVersementTab
                  callBack={callBackTypeAssurance}
                  active={type}
                />

                {type === 'Cotisation' && (
                  <View>
                    <Text style={[styles.label]}>
                      Les
                      <Text style={styles.bold}> cotisations</Text>
                      <View style={[styles.info]}>
                        <Text style={[styles.colorWhite]}>
                          <TooltipWeb
                            title={motClef && motClef.mot}
                            content={motClef && motClef.definition}
                          />
                        </Text>
                      </View>{' '}
                      <Text>que vous souhaiteriez verser</Text>
                    </Text>

                    <FormCotisationWeb
                      isSubmited={isSubmited.cotisation}
                      callBack={callBack}
                      submit={handleSubmit}
                      defaultValue={cotisationDTO}
                      requiredFields={RequiredFieldsCotisation}
                    />
                  </View>
                )}
                {type === 'Capital' && (
                  <View>
                    <Text style={[styles.label]}>
                      Le
                      <Text style={styles.bold}> Capital retraite</Text>
                      <View style={[styles.info]}>
                        <Text style={[styles.colorWhite]}>
                          <TooltipWeb
                            title={motClef && motClef.mot}
                            content={motClef && motClef.definition}
                          />
                        </Text>
                      </View>{' '}
                      que vous souhaiteriez obtenir
                    </Text>

                    <FormCapitalWeb
                      callBack={callBack}
                      submit={handleSubmit}
                      defaultValue={capitalDTO}
                      requiredFields={RequiredFieldsCapital}
                      isSubmited={isSubmited.capital}
                    />
                  </View>
                )}
                {type === 'Pension' && (
                  <View>
                    <Text style={[styles.label]}>
                      La
                      <Text style={styles.bold}> rente</Text>
                      <View style={styles.info}>
                        <Text style={[styles.colorWhite]}>
                          <TooltipWeb
                            title={
                              motClef && motClef.mot === 'PENSION'
                                ? 'RENTE'
                                : motClef && motClef.mot
                            }
                            content={motClef && motClef.definition}
                          />
                        </Text>
                      </View>{' '}
                      que vous souhaiteriez obtenir
                    </Text>

                    <FormPensionWeb
                      callBack={callBack}
                      submit={handleSubmit}
                      defaultValue={pensionDTO}
                      requiredFields={RequiredFieldsPension}
                      isSubmited={isSubmited.pension}
                    />
                  </View>
                )}
              </View>
            </View>
          )}
        </ScrollView>
      </View>
    </Container>
  );
};
export const SimulationCotisation: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimulationCotisationScreen);
